import React, { FC } from 'react';

import { Button } from '@lightspeed/flame/Button';

import { createReactRenderer } from 'helpers/react-renderer';
import { datadogLogs } from 'root/datadog/datadogLogs';

interface Props {
  workorderId: number;
}

const CloneWorkorder: FC<Props> = ({ workorderId }) => {
  const [isDisabled, setIsDisabled] = React.useState<boolean>(false);
  const cloneWorkorderSubmit = async (workorderId: number) => {
    setIsDisabled(true);
    try {
      const accountId = window.merchantos.session.getSystemCustomerID();

      const response = await fetch(
        `/API/V3/Account/${accountId}/Workorder/${workorderId}/Clone.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch Workorder: ${response.status} ${response.statusText}`);
      }

      const responseData = await response.json();

      if (responseData?.Workorder?.workorderID) {
        const clonedWorkorderID = responseData.Workorder.workorderID;
        const currentUrl = new URL(window.location.href);

        const newUrl = `${currentUrl.origin}${currentUrl.pathname}?name=workbench.views.beta_workorder&form_name=view&id=${clonedWorkorderID}&tab=details`;

        window.open(newUrl, '_blank');
      } else {
        datadogLogs.logger.error(`Cloned workorderID missing in response.`);
      }
    } catch (error) {
      datadogLogs.logger.error(`Unable to duplicate Workorder: ${error}`);
      window.alertUser('Something went wrong, try again.');
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <Button
      data-test="duplicate-workorder"
      onClick={() => cloneWorkorderSubmit(workorderId)}
      disabled={isDisabled}
      loading={isDisabled}
      className="supplementary"
    >
      Duplicate
    </Button>
  );
};

const RenderedComponent = createReactRenderer({
  component: CloneWorkorder,
  selector: '[data-react-root="CloneWorkorder"]',
});

history.onChangeState(
  [
    {
      name: ['workbench.views.beta_workorder'],
      form_name: 'view',
      tab: 'details',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default CloneWorkorder;
